<template lang="html">
  <v-container grid-list-sm mt-5>
    <div class="text-xs-center mb-5" v-if="loading">
      <v-progress-circular
      indeterminate
      color="primary"
      ></v-progress-circular>
    </div>
    <v-layout row wrap justify-center>
      <v-flex xs12 md8>
        <v-card>
          <v-container grid-list-xl text-xs-center>
            <v-layout row wrap>
              <v-flex xs12 text-xs-left>
                <h1 class="headline">Profile Information</h1>
              </v-flex>
              <v-flex xs12>
                <v-form>
                  <v-text-field
                    label="User Name"
                    v-model="displayName"
                  ></v-text-field>
                  <v-text-field
                    disabled
                    label="Email Address"
                    :value="user.email"
                  ></v-text-field>
                  <v-text-field
                    disabled
                    type="password"
                    label="Password"
                    value="password"
                  ></v-text-field>
                </v-form>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mb-3" :disabled="!unsavedData" @click="onSave()" block color="accent">Save</v-btn>
                <v-btn
                  block
                  color="error"
                  @click="onLogout()">Logout</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SpProfileEditDialog from './ProfileEditDialog'
import {mapGetters, mapState, mapActions} from 'vuex'
export default {
  computed: {
    displayName: {
      get () {
        return this.$store.state.user.displayName
      },
      set (value) {
        this.$store.commit('user/setUnsavedData', true)
        this.$store.commit('user/setDisplayName', value)
      }
    },
    ...mapState([
      'user'
    ]),
    ...mapGetters({
      unsavedData: 'user/unsavedData',
      loading: 'loading'
    })
  },
  methods: {
    ...mapActions({
      logout: 'user/logout'
    }),
    onSave () {
      this.$store.dispatch('user/saveState', this.$store.state.user)
    },
    onLogout () {
      this.$router.push('/signin')
      this.logout()
    },
    onPickFile () {
      this.$refs.fileInput.click()
    }
  },
  components: {
    SpProfileEditDialog
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Profile/Profile.vue